// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"66abb13d","223":"7670eb26","228":"5d184cba","453":"33592709","834":"e81e223c"}[chunkId] + ".chunk.js";
};